import { z } from "zod";

export const recordingCaptured = z.object({
  type: z.literal("RecordingCaptured"),
  recordingId: z.string().min(1),
  userId: z.string().min(1),
  siteId: z.string().nullable().optional(),
  audioKey: z.string().min(1),
  mime: z.string().min(1),
  duration: z.number().nullable().optional(),
  sizeBytes: z.number().nullable().optional(),
  title: z.string().nullable().optional(),
});

export const recordingTranscribed = z.object({
  type: z.literal("RecordingTranscribed"),
  recordingId: z.string().min(1),
  transcription: z.string(),
  model: z.string(),
});

export const recordingSummarised = z.object({
  type: z.literal("RecordingSummarised"),
  recordingId: z.string().min(1),
  aiSummary: z.string(),
  title: z.string(),
  model: z.string(),
});

export const recordingProcessingFailed = z.object({
  type: z.literal("RecordingProcessingFailed"),
  recordingId: z.string().min(1),
  error: z.string(),
});

export const recordingUpdated = z.object({
  type: z.literal("RecordingUpdated"),
  recordingId: z.string().min(1),
  title: z.string().optional(),
  siteId: z.string().nullable().optional(),
});

export const recordingDeleted = z.object({
  type: z.literal("RecordingDeleted"),
  recordingId: z.string().min(1),
});

export const recordingSummaryApproved = z.object({
  type: z.literal("RecordingSummaryApproved"),
  recordingId: z.string().min(1),
});

export const recordingSummaryRejected = z.object({
  type: z.literal("RecordingSummaryRejected"),
  recordingId: z.string().min(1),
});

export const recordingEvents = [
  recordingCaptured,
  recordingTranscribed,
  recordingSummarised,
  recordingProcessingFailed,
  recordingUpdated,
  recordingDeleted,
  recordingSummaryApproved,
  recordingSummaryRejected,
] as const;
